import { SET_INDUSTRIES, SET_SECTORS, UPDATE_USER_PROFILE } from "./constants";

// create action creator for all the actions here

// setSector action creator
export const setSectors = (sectors) => ({
  type: SET_SECTORS,
  payload: sectors,
});

export const setIndustries = (industries) => ({
  type: SET_INDUSTRIES,
  payload: industries,
});

export const updateUserProfileAction = (profile) => ({
  type: UPDATE_USER_PROFILE,
  payload: profile,
});
